module.exports = __webpack_public_path__ + "static/itsm_capabilities_13-262b4aeb72027d667dbe784d22568be3.png";